(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["helmut-b2b-quick-order"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-hpo]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const rows=[...root.querySelectorAll('[data-hpo-row]')],search=root.querySelector('[data-hpo-search]'),count=root.querySelector('[data-hpo-count]'),total=root.querySelector('[data-hpo-total]'),submit=root.querySelector('[data-hpo-submit]');if(!rows.length||!submit)return;const money=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:'EUR'}),unitOne=root.dataset.unitOne||'unit',unitMany=root.dataset.unitMany||'units',addingText=root.dataset.adding||'Adding…',errorText=root.dataset.error||'Unable to add the selection to cart. Please try again.',taxShort=root.dataset.taxShort||'';const getVariant=row=>{const el=row.querySelector('[data-hpo-variant]');if(!el)return null;if(el.tagName==='SELECT'){const o=el.options[el.selectedIndex];return{id:el.value,price:Number(o.dataset.price||0)}}return{id:el.value,price:Number(el.dataset.price||0)}};const refreshPrice=row=>{const p=row.querySelector('[data-hpo-price]'),v=getVariant(row);if(p&&v)p.textContent=money.format(v.price/100)+(taxShort?' '+taxShort:'')};const refresh=()=>{let units=0,sum=0;rows.forEach(row=>{const q=Math.max(0,Number(row.querySelector('[data-hpo-qty]')?.value||0)),v=getVariant(row);units+=q;if(v)sum+=q*v.price;refreshPrice(row)});count.textContent=units+' '+(units>1?unitMany:unitOne);total.textContent=money.format(sum/100)+(taxShort?' '+taxShort:'');submit.disabled=units===0};rows.forEach(row=>{const q=row.querySelector('[data-hpo-qty]');row.querySelector('[data-hpo-minus]')?.addEventListener('click',()=>{q.value=Math.max(0,Number(q.value||0)-1);refresh()});row.querySelector('[data-hpo-plus]')?.addEventListener('click',()=>{q.value=Math.max(0,Number(q.value||0)+1);refresh()});q?.addEventListener('input',refresh);row.querySelector('select[data-hpo-variant]')?.addEventListener('change',refresh)});search?.addEventListener('input',()=>{const term=search.value.trim().toLowerCase();root.querySelectorAll('[data-hpo-product]').forEach(group=>group.hidden=term&&!group.dataset.search.includes(term))});submit.addEventListener('click',async()=>{const items=rows.map(row=>{const quantity=Math.max(0,Number(row.querySelector('[data-hpo-qty]')?.value||0)),v=getVariant(row);return quantity&&v?{id:v.id,quantity}:null}).filter(Boolean);if(!items.length)return;submit.disabled=true;const old=submit.textContent;submit.textContent=addingText;try{const base=window.Shopify?.routes?.root||'/';const res=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!res.ok)throw new Error();window.location.href=root.dataset.cartUrl||'/cart'}catch(e){submit.disabled=false;submit.textContent=old;window.alert(errorText)}});refresh()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helmut-family-wall"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-helmut-family]');
  roots.forEach((root) => {
    const buttons = root.querySelectorAll('[data-family-filter]');
    const items = root.querySelectorAll('[data-family-item]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.familyFilter;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        items.forEach((item) => {
          const matches = filter === 'all' || item.dataset.category === filter || item.dataset.category === 'all';
          item.hidden = !matches;
        });
      });
    });

    const dialog = root.querySelector('[data-family-dialog]');
    const dialogImage = dialog.querySelector('img');
    root.querySelectorAll('[data-family-open]').forEach((button) => {
      button.addEventListener('click', () => {
        dialogImage.src = button.dataset.full;
        dialogImage.alt = button.dataset.alt;
        dialog.showModal();
      });
    });
    const closeDialog = () => dialog.close();
    root.querySelector('[data-family-close]')?.addEventListener('click', closeDialog);
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helmut-home-commerce"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hlmt-slider-button]');
    if (!button) return;
    const sliderId = button.getAttribute('aria-controls');
    const slider = document.getElementById(sliderId);
    if (!slider) return;
    const card = slider.querySelector('.hlmt-commerce__card');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(slider).columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;
    const direction = button.dataset.hlmtSliderButton === 'previous' ? -1 : 1;
    slider.scrollBy({ left: distance * direction, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helmut-pack-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hlmt-pack]').forEach((root) => {
    const selects = Array.from(root.querySelectorAll('[data-pack-select]'));
    const form = root.querySelector('form');
    const submit = root.querySelector('[data-pack-submit]');
    const originalOutput = root.querySelector('[data-pack-original]');
    const output = root.querySelector('[data-pack-total]');
    const savingsOutput = root.querySelector('[data-pack-savings]');
    const status = root.querySelector('[data-pack-status]');
    const discountRate = Number(root.dataset.discountRate || 10);
    const currency = document.documentElement.dataset.currency || window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'fr';
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });

    const updateTotal = () => {
      const total = selects.reduce((sum, select) => {
        const option = select.options[select.selectedIndex];
        return sum + Number(option?.dataset.price || 0);
      }, 0);
      const discountedTotal = Math.round(total * (100 - discountRate) / 100);
      const savings = total - discountedTotal;
      if (originalOutput) originalOutput.textContent = formatter.format(total / 100);
      if (output) output.textContent = formatter.format(discountedTotal / 100);
      if (savingsOutput) savingsOutput.textContent = `${root.dataset.savingsLabel || ''}${formatter.format(savings / 100)}`;
    };

    selects.forEach((select) => select.addEventListener('change', updateTotal));
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      if (submit) submit.disabled = true;
      if (status) status.textContent = root.dataset.loadingMessage || '';

      try {
        const items = selects.map((select) => ({ id: Number(select.value), quantity: 1 }));
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('Pack add failed');
        window.location.assign(root.dataset.discountUrl);
      } catch (error) {
        if (submit) submit.disabled = false;
        if (status) status.textContent = root.dataset.errorMessage || '';
      }
    });

    updateTotal();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helmut-stockists"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-helmut-stockists]').forEach(function (section) {
    if (section.dataset.stockistsReady === 'true') return;
    section.dataset.stockistsReady = 'true';

    var search = section.querySelector('[data-stockist-search]');
    var pins = Array.from(section.querySelectorAll('[data-stockist-pin]'));
    var details = Array.from(section.querySelectorAll('[data-stockist-detail]'));
    var filters = Array.from(section.querySelectorAll('[data-stockist-filter]'));
    var activeRegion = 'all';

    function normalise(value) {
      return (value || '').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
    }

    function update() {
      var query = normalise(search ? search.value : '');
      pins.forEach(function (pin) {
        var matchesText = normalise(pin.dataset.search).indexOf(query) !== -1;
        var matchesRegion = activeRegion === 'all' || pin.dataset.region === activeRegion;
        var visible = matchesText && matchesRegion;
        pin.hidden = !visible;
        if (!visible) {
          var detail = section.querySelector('[data-stockist-detail="' + pin.dataset.stockistPin + '"]');
          if (detail) detail.hidden = true;
        }
      });
    }

    filters.forEach(function (button) {
      if (button.dataset.stockistFilter !== 'all') {
        var exists = pins.some(function (pin) {
          return pin.dataset.region === button.dataset.stockistFilter;
        });
        button.classList.toggle('is-hidden', !exists);
      }

      button.addEventListener('click', function () {
        activeRegion = button.dataset.stockistFilter;
        filters.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        update();
      });
    });

    pins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        details.forEach(function (detail) {
          detail.hidden = detail.dataset.stockistDetail !== pin.dataset.stockistPin;
        });
      });
    });

    if (search) search.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
